module.exports = __webpack_public_path__ + "img/demand.6636e7ee.svg";